import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { NpmInitFunction, snippet, npmStartPrecheck, npmStartSessions, npmStopSessions, packageType } from '../../constant';
import Tooltip from '../ToolTip';
import './npm-content.scss';

const NpmContent = () => {
	const [npmTypes, setNpmTypes] = useState('npm');

	const { t } = useTranslation();

	const handleCopy = (url) => {
		navigator.clipboard.writeText(url);
	};
	return (
		<div>
			<h1>{t('installation')}</h1>
			<p>{t('mereos_is_a_javaScript_library')}</p>
			<div className='copy-button'>
				<Tooltip message="Copied to clipboard!">
					<button onClick={() => handleCopy(packageType[npmTypes])}>
						{t('copy')}
					</button>
				</Tooltip>
			</div>
			<div className="snippet-box">
				<div className='packages-types'>
					<p className={npmTypes === 'npm' ? 'active' : ''} onClick={() => setNpmTypes('npm')}>npm</p>
					<p className={npmTypes === 'yarn' ? 'active' : ''} onClick={() => setNpmTypes('yarn')}>yarn</p>
					<p className={npmTypes === 'pnpm' ? 'active' : ''} onClick={() => setNpmTypes('pnpm')}>pnpm</p>
				</div>
				<pre className="snippet-code">{packageType[npmTypes]}</pre>
			</div>

			<h1 className='example-heading'>{t('example_usage')}</h1>
			<p>1. <mark>init</mark> {t('function_is_used_to_initiate')} <mark>candidate_object</mark>, <mark>profile_id</mark>, <mark>assessment_object</mark> and <mark>theme_object </mark>.</p>
			<p>Note: <mark>profile_id</mark> {t('is_related_to_proctoring_profile')} <mark>external_id</mark> {t('in_candidate_object_is_a_unique_id')} <mark>external_id</mark> {t('in_assessment_object_is_the_id')}</p>
			<div className='copy-button'>
				<Tooltip message="Copied to clipboard!">
					<button onClick={() => handleCopy(NpmInitFunction)}>
						{t('copy')}
					</button>
				</Tooltip>
			</div>
			<pre>{NpmInitFunction}</pre>
			<p>2. <mark>start_prechecks</mark> {t('function_is_used_to_start_prechecks')}</p>
			<div className='copy-button'>
				<Tooltip message="Copied to clipboard!">
					<button onClick={() => handleCopy(npmStartPrecheck)}>
						{t('copy')}
					</button>
				</Tooltip>
			</div>
			<pre>{npmStartPrecheck}</pre>

			<p>3. <mark>start_session</mark> {t('function_is_used_to_start_the_session')} </p>
			<div className='copy-button'>
				<Tooltip message="Copied to clipboard!">
					<button onClick={() => handleCopy(npmStartSessions)}>
						{t('copy')}
					</button>
				</Tooltip>
			</div>
			<pre>{npmStartSessions}</pre>

			<p>4. <mark>stop_session</mark> {t('function_is_used_to_finish_the_session')} </p>
			<div className='copy-button'>
				<Tooltip message="Copied to clipboard!">
					<button onClick={() => handleCopy(npmStopSessions)}>
						{t('copy')}
					</button>
				</Tooltip>
			</div>
			<pre>{npmStopSessions}</pre>
		</div>
	)
}

export default NpmContent